import * as React from "react";

const IconPlpFilterUp: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <g fill="none" fillRule="evenodd">
                <circle cx="8" cy="8" r="8" fill="#D7D7D7" />
                <polygon
                    fill="currentColor"
                    fillRule="nonzero"
                    points="7.999 10.248 8.328 9.912 11.421 6.757 11.75 6.421 11.093 5.752 10.764 6.088 7.999 8.91 5.234 6.086 4.905 5.75 4.25 6.421 4.579 6.757 7.67 9.914 7.999 10.25"
                    transform="matrix(1 0 0 -1 0 16)"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconPlpFilterUp);
